module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/join-2-e1615698a78b7552bfcbab20b6c8d01d.svg";